export default __webpack_public_path__ + "static/media/inventMgmt3.49cf6bea.png";